import PropTypes from "prop-types";
import classNames from "classnames";
import SinglePageAppLink from "../../../../components/SinglePageAppLink";
import styles from "./GuidedSearchTextTile.css";

export const GuidedSearchTextTile = ({
  selectionKey,
  name,
  linkUrl,
  isSelected,
  onSelect,
}) => (
  <li
    className={styles.tile}
    data-guided-search-selected={isSelected ? "true" : "false"}
  >
    <SinglePageAppLink
      href={linkUrl}
      className={classNames(styles.link, {
        [styles.linkSelected]: isSelected,
      })}
      onClick={() => onSelect(selectionKey)}
    >
      <span
        className={classNames(styles.label, {
          [styles.labelSelected]: isSelected,
        })}
      >
        {name}
      </span>
    </SinglePageAppLink>
  </li>
);

GuidedSearchTextTile.propTypes = {
  selectionKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  name: PropTypes.string.isRequired,
  linkUrl: PropTypes.string.isRequired,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
};

export default GuidedSearchTextTile;
